import {
  PixOutlineIcon,
  DocumentSingleIcon,
  CardIcon,
  StoreIcon,
} from '@grupoboticario/flora-react-icons';
import { theme } from 'ui/theme';

const commonProps = { color: theme.colors.build.mediumLight1 };

export const paymentTypes = {
  pixPayment: {
    label: `Use seu crédito de revendedora e parcele sua compra pagando 
    no Pix sem taxas. O seu limite de crédito é liberado logo após o pagamento.`,
    icon: <PixOutlineIcon css={{ ...commonProps }} />,
    showNewBagde: true,
    singleOption: false,
  },
  bankSlip: {
    label: `Use seu crédito de revendedora parcele a sua compra pagando com código de barras.
   O seu limite de crédito é liberado em 48 horas.`,
    icon: <DocumentSingleIcon css={{ ...commonProps }} />,
    showNewBagde: false,
    singleOption: false,
  },
  creditCard: {
    label: `Use o crédito do seu próprio cartão e parcele em até 10x sem juros.`,
    icon: <CardIcon css={{ ...commonProps }} />,
    showNewBagde: false,
    singleOption: false,
  },
  centralPayment: {
    label: `Pague com cartão quando receber o pedido no seu endereço.`,
    icon: <CardIcon css={{ ...commonProps }} />,
    showNewBagde: false,
    singleOption: true,
  },
  linkPayment: {
    label: `A definir na retirada`,
    icon: <StoreIcon css={{ ...commonProps }} />,
    showNewBagde: false,
    singleOption: true,
  },
};
